import { CustomCellRendererProps } from 'ag-grid-react';
import { RoundNameRenderer } from '../../../components/AgTable/cell-renderers/RoundRenderer';

function formatFundingStage(raw: string | null | undefined): string {
  if (!raw || raw.toUpperCase() === 'UNKNOWN') {
    return '';
  }
  return raw
    .replace(/_/g, ' ')
    .toLowerCase()
    .replace(/\b\w/g, (c) => c.toUpperCase());
}

export function FundingStageCellRenderer({ value }: CustomCellRendererProps) {
  const name = formatFundingStage(value as string | null | undefined);
  if (!name) {
    return null;
  }
  return <RoundNameRenderer name={name} style={{ fontSize: 14, margin: 0 }} />;
}
